module.exports = __webpack_public_path__ + "static/media/geren_2.e7401a61.png";